import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'
import { notify } from 'notiwind'
import i18n from '@/i18n/i18n'

const doNotify = (title, text, duration = 6000, group = 'error') => {
  notify(
    {
      group: group,
      title,
      text
    },
    duration
  )
}

const checkPersonEligibleity = async () => {
  const formStore = useFormStore()
  const { familyBookCityCode, familyBooKFamilySequence } = formStore.form.values || {}
  if (!familyBookCityCode || !familyBooKFamilySequence) return

  try {
    const result = await apiHelperService.get(
      `/api/individual/citizen/canApply/${familyBookCityCode}/${familyBooKFamilySequence}`
    )
    if (result?.errorMessage) {
      doNotify(i18n.global.t(result.errorMessage), i18n.global.t(result.errorMessage))
      formStore.form.setValues({
        familyBookCityCode: '',
        familyBooKFamilySequence: ''
      })
    }
  } catch (error) {
    console.error('checkPersonEligibleity', error)
  }
}

export default function (actionName, actionParams) {
  switch (actionName) {
    case 'checkPersonEligibleity':
      checkPersonEligibleity(actionParams)
      break
    default:
      break
  }
}
